import React from "react";
import FormPage from "./FormPage"
import RemoveCaregiverToJobForm from "../components/RemoveCaregiverFromJobForm/RemoveCaregiverFromJobForm"
const CaregiverToJobRemove = () => (
    <FormPage title="Remove caregiver from job" form={<RemoveCaregiverToJobForm/>} />
)

export default CaregiverToJobRemove;